'use strict';

//Utility
import React from 'react';
import autoBind from 'react-autobind';
//Components
import SectionHeader from '../Common/SectionHeader.jsx';
import RadioInput from '../Common/RadioInput.jsx';
//Constants
import ApplicationConstants from '../../constants/ApplicationConstants';
//Store
import SpecialRequestsStore from '../../stores/SpecialRequestsStore.js';
//Action
import SpecialRequestsActions from '../../actions/SpecialRequestsActions.js';


function getStateFromStores() {
    return {
        model: SpecialRequestsStore.getSpecialRequestsModel()
    };
}

export default class SpecialRequestsSection extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getStateFromStores();
    }
    componentDidMount() {
        SpecialRequestsStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        SpecialRequestsStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(getStateFromStores());
    }

    updateSpecialRequest(e) {
        this.updateSpecialRequestsModel(e.target.model, e.target.value);
    }

    updateSpecialRequestDetails(e) {
       this.updateSpecialRequestsModel(e.target.name, e.target.value);
    }

    updateSpecialRequestsModel(fieldId, value) {
        SpecialRequestsActions.updateSpecialRequestsModel(fieldId, value);
    }

    render () {
        return (
           <div className="specialRequestsSection" id="specialRequestsSection">
               <SectionHeader focus={this.props.focus} sectionName="Special requests" />
               <section className="container">
                    <RadioInput id="specialRequestsSection"
                                data={ApplicationConstants.YesNoRadioData}
                                value={this.state.model.isWithSpecialRequests}
                                label="Do you have additional instructions that relate to this application?"
                                model="isWithSpecialRequests"
                                onChange={this.updateSpecialRequest} />
                   { this.state.model.isWithSpecialRequests === ApplicationConstants.YesNoValues.YES ?
                    <textarea rows="4" cols="50" 
                              className="sr-textarea"
                              placeholder="Maximum 1000 characters allowed"
                              onChange={this.updateSpecialRequestDetails}
                              name="specialRequestsDetails"
                              maxLength="1000"
                              value={this.state.model.specialRequestsDetails} />
                   : null }
               </section>
           </div>
        );
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/SpecialRequests/SpecialRequestsSection.jsx